import React, { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import utagObjectAtom from '../../recoils/useUtagObject/utagObjectAtom';
import { callGTMAnalytics } from '../../helper/analyticsTag';

interface IProps {
  rohsStatus: any;
}

export const RohsIcon: React.FC<IProps> = (props: any) => {
  const [lang, setLang] = useState<string>('en');
  const [utagData] = useRecoilState(utagObjectAtom);
  useEffect(() => {
    const pathName = window.location.pathname;
    const langParam = pathName?.split('/')[1];
    setLang(langParam);
  }, []);

  if (props.rohsStatus === 'Rohs3Compliant') {
    return (
      <div style={{ margin: 'auto' }}>
        <a
          className="rohs-icon"
          href={`/${lang}/resources/environmental/initiative`}
          target="_blank"
          rel="noreferrer"
          onClick={()=>callGTMAnalytics(utagData, "Environment Page")}
          cookie-tracking={'ref_page_event=Environment Page'}
        >
          <span className="icon-leaf"></span>
        </a>
      </div>
    );
  }

  return <div></div>;
};
